import { useToast } from "vue-toast-notification";

const toast = useToast({
    position: "top",
    duration: 5000,
    dismissible: true
});

export function showNotification(msg: string, type: "info" | "error" | "warning" | "success") {
    toast.open({
        message: msg,
        type: type
    });
}
